<div class="pos-r mb-xxxs" [formGroup]="form">
	<div class="d-f fd-c mt-xxxs mb-nano">
		<div class="d-f ai-c mb-xxxs fields">
			<div class="d-f fd-c jc-c col org">
				<mat-form-field
					class="w-100"
					title="Organização"
					appearance="outline"
					*ngIf="editing"
				>
					<mat-label>Organização</mat-label>
					<input
						type="text"
						matInput
						placeholder="Organização"
						formControlName="organization_name"
						id="sno-{{ inputId }}"
					/>
				</mat-form-field>
				<mat-form-field
					title="Organização"
					appearance="outline"
					*ngIf="!editing"
				>
					<mat-label>Organização</mat-label>
					<mat-select
						formControlName="organization_id"
						(selectionChange)="onOrgChange($event.value)"
					>
						<mat-option *ngFor="let org of orgOpts" [value]="org.id">
							{{ org.name }}
						</mat-option>
					</mat-select>
					<mat-error *ngIf="form.controls.organization_id.hasError('required')">
						Campo obrigatório
					</mat-error>
				</mat-form-field>
			</div>
			<div class="d-f fd-c jc-c ml-xxs col type">
				<mat-form-field class="smc" title="Tipo" appearance="outline">
					<mat-label>Tipo</mat-label>
					<mat-select formControlName="name">
						<mat-option *ngFor="let type of typeOpts" [value]="type.id">
							{{ type.name }}
						</mat-option>
					</mat-select>
					<mat-error *ngIf="form.controls.name.hasError('required')">
						Campo obrigatório
					</mat-error>
				</mat-form-field>
			</div>
		</div>
		<div class="d-f ai-c">
			<div class="d-f fd-c jc-c w-100">
				<mat-form-field class="w-100" title="Link" appearance="outline">
					<mat-label>Link</mat-label>
					<input
						type="text"
						matInput
						placeholder="Link"
						formControlName="link"
						id="snf-{{ inputId }}"
					/>
					<mat-error *ngIf="form.controls.link.hasError('required')">
						Campo obrigatório
					</mat-error>
				</mat-form-field>
			</div>
		</div>
		<div class="d-f jc-fe">
			<div class="d-f jc-c ai-c btn-loader" *ngIf="isWorking">
				<mat-spinner diameter="20"></mat-spinner>
			</div>
			<button
				mat-flat-button
				color="primary"
				[disabled]="isWorking || form.invalid"
				(click)="onSaveLink()"
				*ngIf="!isWorking"
			>
				Salvar
			</button>
		</div>
	</div>
</div>
<div class="d-f jc-c ai-c mt-sm w-100 loader" *ngIf="loading$ | async">
	<mat-spinner diameter="20"></mat-spinner>
</div>
